if (typeof PromoCarousel === 'undefined') {
  class PromoCarousel extends HTMLElement {
    constructor() {
      super()

      this.interval = Number(this.dataset.interval) || 0
      this.autoplay = Boolean(this.dataset.autoplay) || false
      this.intervalObj = null

      this.slider = this.querySelector('ul')
      this.itemClassName = this.slider.getAttribute('data-classes')
      this.linkClasses = ["cursor-pointer"]
      this.setLinkClasses = this.setLinkClasses.bind(this)
      this.items = this.querySelectorAll('li')
      this.totalItems = this.items.length
      this.slide = 0
      this.moving = true

      this.newPrevious = 0
      this.newNext = 0
      this.oldPrevious = 0
      this.oldNext = 0

      this.prevButton = this.querySelector('button[name="previous"]')
      this.nextButton = this.querySelector('button[name="next"]')
      this.stopAutoPlay = this.stopAutoPlay.bind(this)
      this.startAutoPlay = this.startAutoPlay.bind(this)
      this.movePrev = this.movePrev.bind(this)
      this.moveNext = this.moveNext.bind(this)

      this.setNavFontColors = this.setNavFontColors.bind(this)
      this.adFontItems = document.querySelectorAll('.js-ad-font-color')

      if (!this.slider || !this.nextButton) return

      this.prevButton.addEventListener('click', (e) => {
        this.stopAutoPlay()
        if (!window.IS_MOTION_PAUSED) {
          this.moving = false
          this.movePrev()
          this.startAutoPlay()
        }
      })
      this.nextButton.addEventListener('click', (e) => {
        this.stopAutoPlay()
        this.moving = false
        this.moveNext()
        this.startAutoPlay()
      })

      this._swipeMoveNext = this._swipeMoveNext.bind(this)
      this._swipeMovePrev = this._swipeMovePrev.bind(this)

      this.initCarousel()
    }

    connectedCallback() {
      if (this.slider && this.nextButton) {
        this._attachListeners()
      }
    }

    disconnectedCallback() {
      if (this.slider && this.nextButton) {
        this._removeListeners()
      }
    }

    initCarousel() {
      if (this.totalItems <= 1) return

      if (this.totalItems > 1) {
        if (this.totalItems === 2) {
          this.items[0].cloneNode(true)
          this.slider.appendChild(this.items[0].cloneNode(true))
          this.slider.appendChild(this.items[1].cloneNode(true))
          this.slider.appendChild(this.items[0].cloneNode(true))
          this.slider.appendChild(this.items[1].cloneNode(true))
        } else if (this.totalItems === 3) {
          this.slider.appendChild(this.items[0].cloneNode(true))
          this.slider.appendChild(this.items[1].cloneNode(true))
          this.slider.appendChild(this.items[2].cloneNode(true))
        } else if (this.totalItems === 4) {
          this.slider.appendChild(this.items[0].cloneNode(true))
          this.slider.appendChild(this.items[1].cloneNode(true))
          this.slider.appendChild(this.items[2].cloneNode(true))
          this.slider.appendChild(this.items[3].cloneNode(true))
        }

        this.items = this.querySelectorAll('li')
        this.totalItems = this.items.length
      }
      this.setNavFontColors(this.items[0])

      this.setInitialClasses()

      // Set moving to false so that the carousel becomes interactive
      this.moving = false
    }

    setInitialClasses() {
      // Targets the previous, current, and next items
      // This assumes there are at least three items.
      this.items[this.totalItems - 1].className = this.itemClassName + ' prev'
      this.items[0].className = this.itemClassName + ' active'
      this.items[1].className = this.itemClassName + ' next'

      this.items.forEach((el) => {
        this.setLinkClasses(el, true)
      })
    }

    setLinkClasses(el, addEvent) {
      const url = el.lastElementChild.getAttribute('href')
      if(url) {
        el.className = el.className + ' ' + this.linkClasses.join(' ')
        if(addEvent) {
          el.addEventListener('click', () => {
            window.location.href = url
          })
        }
      }
    }

    moveNext() {
      if (!this.moving) {
        // If it's the last slide, reset to 0, else +1
        if (this.slide === this.totalItems - 1) {
          this.newPrevious = this.totalItems - 1
          this.newNext = 1
          this.oldPrevious = this.totalItems - 2
          this.oldNext = 0

          this.slide = 0
        } else {
          this.newPrevious = this.slide
          this.newNext = this.slide === this.totalItems - 2 ? 0 : this.slide + 2
          this.oldPrevious =
            this.slide === 0 ? this.totalItems - 1 : this.slide - 1
          this.oldNext = this.slide + 1

          this.slide++
        }
        // Move carousel to updated slide
        this.moveCarouselTo(true)
      }
    }

    movePrev() {
      if (!this.moving) {
        // If it's the last slide, reset to 0, else +1
        if (this.slide === 0) {
          this.newPrevious = this.totalItems - 2
          this.newNext = 0
          this.oldPrevious = this.totalItems - 1
          this.oldNext = 1

          this.slide = this.totalItems - 1
        } else {
          this.newPrevious =
            this.slide === 2
              ? 0
              : this.slide === 1
              ? this.totalItems - 1
              : this.slide - 2
          this.newNext = this.slide
          this.oldPrevious = this.slide - 1
          this.oldNext = this.slide === this.totalItems - 1 ? 0 : this.slide + 1

          this.slide--
        }
        // Move carousel to updated slide
        this.moveCarouselTo(false)
      }
    }

    setNavFontColors(el) {
      this.adFontItems.forEach( (fontItem) => {
        fontItem.style.color = el.dataset.fontColor
        // SVG's need fill/stroke set
        fontItem.style[fontItem.dataset.fontChange] = el.dataset.fontColor
      })
    }

    disableInteraction() {
      // Set 'moving' to true for the same duration as our transition.
      // (0.5s = 500ms)

      this.moving = true
      // setTimeout runs its function once after the given time
      const self = this
      setTimeout(function () {
        self.moving = false
      }, 500)
    }

    moveCarouselTo(toNext) {
      // Check if carousel is moving, if not, allow interaction
      if (!this.moving) {
        // temporarily disable interactivity
        this.disableInteraction()

        // Test if carousel has more than three items
        if (this.totalItems - 1 > 3) {
          if (toNext) {
            this.items[this.newNext].className =
              this.itemClassName + ' next-old'
          } else {
            this.items[this.newPrevious].className =
              this.itemClassName + ' prev-old'
          }

          setTimeout(() => {
            this.items[this.oldPrevious].className = ''
            this.items[this.oldNext].className = ''
            // Add new classes
            this.items[this.newPrevious].className =
              this.itemClassName + ' prev-old prev'
            this.items[this.slide].className = this.itemClassName + ' active'
            this.items[this.newNext].className =
              this.itemClassName + ' next-old next'

            this.setLinkClasses(this.items[this.slide], false)
            this.setNavFontColors(this.items[this.slide])
          }, 100)
        }

        document.querySelector(
          '.js-announcement-bar-wrapper'
        ).style.backgroundColor = this.items[this.slide].dataset.bg
      }
    }

    _swipeMoveNext(event) {
      this.stopAutoPlay()
      this.moving = false
      this.moveNext()
      this.startAutoPlay()
    }

    _swipeMovePrev(event) {
      this.stopAutoPlay()
      this.moving = false
      this.movePrev()
      this.startAutoPlay()
    }

    startAutoPlay() {
      if (this.autoplay) {
        this.intervalObj = setInterval(() => {
          this.moving = false
          this.moveNext()
        }, this.interval)
      }
    }

    stopAutoPlay() {
      if (this.intervalObj) clearInterval(this.intervalObj)
    }

    _attachListeners() {
      this.addEventListener('swiped-left', this._swipeMoveNext, false)
      this.addEventListener('swiped-right', this._swipeMovePrev, false)
      this.startAutoPlay()
    }

    _removeListeners() {
      this.removeEventListener('swiped-left', this._swipeMoveNext, false)
      this.removeEventListener('swiped-right', this._swipeMovePrev, false)
      this.stopAutoPlay()
    }
  }

  if (customElements.get('promo-carousel') === undefined) {
    customElements.define('promo-carousel', PromoCarousel)
  }
}
